const HANDLEBARS_VAR_PATTERN = /\{\{([A-Za-z][A-Za-z0-9_]*)\}\}/g;
const HTML_TAG_OR_AT_VARIABLE_PATTERN = /<[^>]+>|@([A-Za-z][A-Za-z0-9_]*)(?![A-Za-z0-9_])/g;

export function buildMentionHtml(varKey: string): string {
  return (
    `<span class="mention" data-id="${varKey}" data-value="${varKey}" data-denotation-char="@">` +
    `<span class="ql-mention-denotation-char">@</span>` +
    `<span class="ql-mention-value">${varKey}</span></span>`
  );
}

/** Convierte {{var}} o @var en HTML con menciones reconocibles por Quill. */
export function hydrateMentionsInHtml(html: string): string {
  if (!html) {
    return '';
  }

  const withHandlebars = html.replace(HANDLEBARS_VAR_PATTERN, (_, varKey: string) => buildMentionHtml(varKey));

  return withHandlebars.replace(HTML_TAG_OR_AT_VARIABLE_PATTERN, (token, varKey?: string) => {
    if (token.startsWith('<')) {
      return token;
    }
    return buildMentionHtml(varKey!);
  });
}
